<template>
  <div class="d-flex flex-column gap-2">
    <div v-for="(year, yearIndex) in years" :key="yearIndex" class="year">
      <template v-for="(child, index) in year" :key="index">
        <div v-if="!(index % 2)" class="year__year">
          <span>{{ $t("Year") }} {{ child?.vars?.value?.year }}</span>
        </div>
        <template v-for="item1 in child?.children" :key="item1.vars?.id">
          <div v-if="!isHiddenType(item1)" class="year__item">
            <ModelComponent :model="item1" />
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { formManager } from "@/services/form/form-manager";
import { defineAsyncComponent } from "vue";

export default {
  name: "RegistrationApprenticeSalaryTableComponent",
  components: { ModelComponent: defineAsyncComponent(() => import("@/components/form/ModelComponent.vue")) },
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  computed: {
    years() {
      return [
        [this.model?.children[0], this.model?.children[1]],
        [this.model?.children[2], this.model?.children[3]],
        [this.model?.children[4], this.model?.children[5]],
        [this.model?.children[6], this.model?.children[7]],
      ];
    },
  },
  data() {
    return {
      itemModel: this.model,
    };
  },
  beforeCreate: function () {
    this.$options.components.ModelComponent = require("@/components/form/ModelComponent.vue").default;
  },
  methods: {
    isHiddenType(model) {
      return formManager.isHiddenType(model);
    },
  },
};
</script>

<style lang="scss" scoped>
.year {
  display: grid;
  grid-template-columns: repeat(9, minmax(0, 1fr));
  gap: 10px;
  align-items: baseline;
  padding: 8px;
  border-radius: 6px;

  &:nth-child(2n + 1) {
    background: $light-blue;

    @include dark-theme {
      background: $m-color_18;
    }
  }

  &__year,
  &__item {
    width: 100%;
  }
}
</style>
